import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    minHeight: "80.5vh",
    fontFamily: "Nunito",
    background: "#fff",
  },
  grid: { width: "100%", margin: theme.spacing(0) },
}));
const Testimonials = (props) => {
  const classes = useStyles();

  const { setCurrPage } = props;

  useEffect(() => {
    setCurrPage("Testimonials");
  }, [setCurrPage]);

  return (
    <div className={classes.root}>
      <Grid
        className={classes.grid}
        container
        spacing={1}
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12}>
          <h1>Please Rate us on Google!</h1>
        </Grid>
      </Grid>
    </div>
  );
};
export default Testimonials;
